import React from "react";
import { IMenuItem } from "../../@types/types";
import FeatherIcon from "feather-icons-react";
import { handleLinkClick } from "../../utils";

interface QuickLinksProps {
  quickLinks: IMenuItem[];
  isSearch: boolean;
}

const QuickLinks: React.FC<QuickLinksProps> = ({ quickLinks, isSearch }) => {
  return (
    <div className='quick-links'>
      <span
        className='quick-links-heading'
        style={!isSearch ? { marginTop: "8px" } : {}}
      >
        Quick Links
      </span>
      {quickLinks.map((item) => {
        if (item.isVisible) {
          return (
            <div
              className='quick-links-items'
              key={item.id}
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleLinkClick(item.targetUrl, item.targetType === "BLANK");
              }}
            >
              {item.iconClass ? (
                <FeatherIcon icon={item.iconClass} height='24px' width='24px' />
              ) : null}
              {item.targetType === "BLANK" ? (
                <a
                  href={item.targetUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={item.iconClass ? { marginLeft: "10px" } : {}}
                >
                  {item.title}
                </a>
              ) : (
                <a
                  href={item.targetUrl}
                  style={item.iconClass ? { marginLeft: "10px" } : {}}
                >
                  {item.title}
                </a>
              )}
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};

export default QuickLinks;
